import { Injectable } from "@angular/core";
import { forkJoin, map, mergeMap, Observable, of } from "rxjs";
import { ApiService } from "../../../../SGRE-shared/services/api.service";
import { environment } from "../../../../../environments/environment";
import { CarouselItem, HomePageConstants } from "../../models/homepage.model";
import { itemState } from "../homepage.state";

@Injectable()
export class HomePageEffectsService {

    constructor(
        private apiService: ApiService,
    ) { }

    fetchCarouselImages(bannersImages: string[]): Observable<CarouselItem[]> {
        const fields: string = HomePageConstants.DEFAULT;
        const currentPage = 0;
        const pageSize: number = bannersImages.length;

        return of(bannersImages).pipe(
            mergeMap((banners: string[]) => {
                return forkJoin(
                    banners.map((banner: string) => {
                        return this.apiService.getCarouselImagesHome(fields, currentPage, pageSize, banner);
                    })
                );
            })
        );
    }

    getCarouselImages(bannersImages: string[]): Observable<string[]> {
        const array: string[] = [];
        let fetchedData: CarouselItem[];

        return this.fetchCarouselImages(bannersImages).pipe(
            map((data) => {
                fetchedData = data;
                if (fetchedData?.length > 0) {
                    for (const item of fetchedData) {
                        array.push(environment.siteUrls.getBackofficeUrl + item.component?.[0]?.media?.url);
                    }
                }
                return array;
            })
        );
    }

    filterCategories(data: itemState[]): itemState[] {
        const filterData: itemState[] = data.filter(
            (item: itemState) => item.code !== HomePageConstants.TOP_PRODUCTS
        );
        const imageUrl: string = environment.siteUrls.getBackofficeUrl?.slice(0, -1) || '';

        const updatedFilterData = filterData.map((item: itemState) => {
            const imgUrl = imageUrl + item?.image?.url;
            return { ...item, imgUrl };
        });

        return updatedFilterData;
    }
}